import clsx from 'clsx'

import useAppSelector from '../../../../store/hooks/useAppSelector'
import HeadingText from '../../../app/components/HeadingText'
import { productSelectedMenuGroupProductsSelector } from '../../../product/store/productSelectors'
import useCartDrawerOpen from '../../../checkout/hooks/useCartDrawerOpen'
import { AppTestIds } from '../../../app/constants'

import OutletMenuProductCard from './OutletMenuProductCard'
import styles from './OutletMenuProductList.module.scss'

type OutletMenuProductListProps = {
  productIds: string[]
  title?: string
}

export default function OutletMenuProductList({
  productIds,
  title,
}: OutletMenuProductListProps) {
  const products = useAppSelector(state =>
    productSelectedMenuGroupProductsSelector(state, productIds),
  )
  const cartDrawerOpen = useCartDrawerOpen()

  return (
    <div className={styles.container}>
      {title && <HeadingText as="h3">{title}</HeadingText>}
      <div
        className={clsx(styles.gridContainer, {
          [styles.gridWithDrawer]: cartDrawerOpen,
        })}
      >
        {products.map(product => (
          <div
            key={product.id}
            data-testid={AppTestIds.Outlet.Menu.ProductList.ProductCard}
          >
            <OutletMenuProductCard product={product} />
          </div>
        ))}
      </div>
    </div>
  )
}
